import React from 'react';
import { CalendarIcon, TagIcon, ExternalLinkIcon } from 'lucide-react';
export interface Publication {
  id: string;
  title: string;
  journal: string;
  year: number;
  authors: string[];
  abstract: string;
  tags: string[];
  doi: string;
  coverColor: string;
}
interface PublicationCardProps {
  publication: Publication;
  targetAuthor: string;
}
export function PublicationCard({
  publication,
  targetAuthor
}: PublicationCardProps) {
  return <article className="py-6 border-b border-[#E0E0E0] last:border-0 flex gap-4 md:gap-6 group" data-id="element-34">
      <div className="flex-shrink-0 hidden sm:block" data-id="element-35">
        <div className="w-16 h-20 rounded shadow-sm border border-black/10 flex items-center justify-center text-white/50 text-xs font-serif" style={{
        backgroundColor: publication.coverColor
      }} data-id="element-36">
          {publication.journal.substring(0, 2).toUpperCase()}
        </div>
      </div>

      <div className="flex-1 min-w-0" data-id="element-37">
        <h2 className="text-lg font-serif font-medium text-[#1B5E20] hover:text-[#2E7D32] cursor-pointer leading-snug mb-2" data-id="element-38">
          {publication.title}
        </h2>

        <div className="text-sm text-gray-800 mb-2 leading-relaxed" data-id="element-39">
          {publication.authors.map((author, index) => {
          const isTarget = author === targetAuthor;
          return <span key={index} data-id="element-40">
                <span className={isTarget ? 'font-bold text-gray-900' : ''} data-id="element-41">
                  {author}
                </span>
                {index < publication.authors.length - 1 ? ', ' : ''}
              </span>;
        })}
        </div>

        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600 mb-3" data-id="element-42">
          <span className="italic font-serif" data-id="element-43">{publication.journal}</span>
          <span className="flex items-center gap-1" data-id="element-44">
            <CalendarIcon className="w-3 h-3" data-id="element-45" />
            {publication.year}
          </span>
          <a href="#" className="flex items-center gap-1 text-[#2E7D32] hover:underline" data-id="element-46">
            <ExternalLinkIcon className="w-3 h-3" data-id="element-47" />
            {publication.doi}
          </a>
        </div>

        <p className="text-sm text-gray-600 leading-relaxed mb-3 line-clamp-2 md:line-clamp-3" data-id="element-48">
          {publication.abstract}
        </p>

        <div className="flex flex-wrap gap-2" data-id="element-49">
          {publication.tags.map((tag, index) => <span key={index} className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#F5F7F8] text-gray-600 text-xs rounded border border-[#E0E0E0]" data-id="element-50">
              <TagIcon className="w-3 h-3 text-gray-400" data-id="element-51" />
              {tag}
            </span>)}
        </div>
      </div>
    </article>;
}